module.exports = __webpack_public_path__ + "static/image/service/pc/taste@3x.jpg?09035205";